<!-- New Template -->

<ion-grid>
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336" *ngIf="companyList$ | async as compList">
				<ng-container *ngIf="compList.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container>
				<ng-container *ngIf="!compList.isSkeleton">
					<ion-row>
						<ion-col col="12">
							<dx-data-grid
								id="gridContainer"
								[dataSource]="compList.data"
								keyExpr="id"
								[allowColumnResizing]="true"
								[columnAutoWidth]="true"
								[showBorders]="true"
							>
								<dxo-search-panel
									[visible]="true"
									[width]="240"
									placeholder="Search..."
								></dxo-search-panel>
								<dxo-header-filter
									[visible]="showHeaderFilter"
								></dxo-header-filter>
								<dxo-column-chooser
									[enabled]="true"
									mode="select"
								></dxo-column-chooser>
								<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

								<dxi-column
									caption="Actions"
									dataField="id"
									[allowFiltering]="false"
									[allowSorting]="false"
									cellTemplate="cellTemplate"
									[width]="150"
								>
								</dxi-column>

								<dxi-column
									dataField="name"
									caption="Name"
									[width]="150"
									[visible]="true"
								></dxi-column>
								<dxi-column
									dataField="email"
									caption="Email"
									[width]="150"
									[visible]="true"
								></dxi-column>
								<dxi-column
									dataField="domain"
									caption="Domain"
									[width]="150"
									[visible]="true"
								></dxi-column>

								<dxi-column
									dataField="url"
									caption="Url"
									[width]="150"
									[visible]="true"
								></dxi-column>
								<dxi-column
									dataField="submissionDate"
									caption="TypeformSubmissionDate"
									[width]="150"
									dataType="datetime"
									format="dd/MM/yyyy hh:mm aa"
									[visible]="true"
								></dxi-column>
								<dxi-column
									dataField="approvalDate"
									caption="Approval/Reject Date"
									[width]="150"
									dataType="datetime"
									format="dd/MM/yyyy hh:mm aa"
									[visible]="true"
								></dxi-column>
								<dxi-column
									dataField="createdAt"
									caption="CreatedDate"
									[width]="150"
									dataType="datetime"
									format="dd/MM/yyyy hh:mm aa"
									[visible]="true"
								></dxi-column>
								<dxi-column
									cellTemplate="cellTemplateLogo"
									dataField=""
									caption="Logo"
								></dxi-column>
								<div
									*dxTemplate="let d of 'cellTemplateLogo'"
									class="text-center"
								>
									<img [src]="d.data.logoUrl" class="logoUrl" />
								</div>

								<div *dxTemplate="let d of 'cellTemplate';">
									<a
										appConfirmBox
										(learnDelete)="updateCompanyStatus(d.data.id,'approved')"
										title="Update company status"
										subTitle="Are you sure you want to update company status?"
										buttonText="Yes, Update"
										class="cursor"
										*ngIf="d.data.approveStatus !== 'approved'"
										><b>Approve</b></a
									>
									<ng-container *ngIf="d.data.approveStatus === 'pending'">
										/
									</ng-container>
									<a
										appConfirmBox
										(learnDelete)="updateCompanyStatus(d.data.id,'rejected')"
										title="Update company status"
										subTitle="Are you sure you want to update company status?"
										buttonText="Yes, Update"
										class="cursor"
										*ngIf="d.data.approveStatus !== 'rejected'"
										><b>Reject</b></a
									>
								</div>

								<dxo-toolbar>
									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<p class="Heading_M">Approve EPP SignUps</p>
										</div>
									</dxi-item>

									<dxi-item>
										<ion-buttons class="center">
											Company Status :
											<ion-select
												placeholder="Select Status"
												interface="popover"
												(ionChange)="handleChange($event)"
												value="pending"
											>
												<ion-select-option value="pending" selected
													>Pending</ion-select-option
												>
												<ion-select-option value="approved"
													>Approved</ion-select-option
												>
												<ion-select-option value="rejected"
													>Rejected</ion-select-option
												>
											</ion-select>
										</ion-buttons>
									</dxi-item>

									<dxi-item name="columnChooserButton"></dxi-item>

									<dxi-item name="searchPanel"></dxi-item>
								</dxo-toolbar>
							</dx-data-grid>
						</ion-col>
					</ion-row>
				</ng-container>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>
